// removed by extract-text-webpack-plugin
module.exports = {"mainSliderContainer":"mainSliderContainer__1HfI0","bannerImgOuterContainer":"bannerImgOuterContainer__YkGLr","bannerImgContainer":"bannerImgContainer__19cvZ","lightboxContainer":"lightboxContainer__1MU3l","videoFrame":"videoFrame__3FOaG","closeAction":"closeAction__1_q0Y","arrowSize":"arrowSize__38-N3","educationalModalDialogBody":"educationalModalDialogBody__P1Q0B","closeEducationalModal":"closeEducationalModal__2y4p-","educationModalDialog":"educationModalDialog__1v5bQ"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/banners/style.css
// module id = AHpe
// module chunks = 323